{
  "API Log": "API Log",
  "Menu": "Menu",
  "admin": {
    "Database": "Database",
    "Laravel Log Dosyası": "Laravel Log Bestand",
    "Toplam": "Totaal",
    "laravel log": "Laravel Log",
    "Silme başarısız.": "Verwijderen mislukt.",
    "Banka": "Bank",
    "Bankaları güncelle": "Banken bijwerken",
    "Tatil": "Vakantie",
    "Tatilleri güncelle": "Vakanties bijwerken",
    "İl/İlçe": "Provincie/District",
    "İl ve ilçeleri güncelle": "Provincies en districten bijwerken"
  }
}
